<template>
  <v-col
    class="pa-0"
  >
    <v-row class="ma-0">
      <bread-crumbs />

      <v-col
        class="mr-2"
      >
        <v-row class="justify-end">
          <v-col
            v-if="hasAccessToBurtForecastLink"
            class="col-auto"
          >
            <v-btn
              class="purple"
              style="background-color: #8c46ff !important; border-color: #8c46ff !important;"
              aria-label="Open BurtForecast in a new tab"
              dark
              small
              title="Open BurtForecast in a new tab"
              @click="goToBurtForecast"
            >
              <font-awesome-icon :icon="['far', 'up-right-from-square']" />
              <span class="ml-2">Open BurtForecast</span>
            </v-btn>
          </v-col>

          <v-col
            v-if="hasAccessToBurtHubLink"
            class="col-auto"
          >
            <v-btn
              class="purple"
              style="background-color: #8c46ff !important; border-color: #8c46ff !important;"
              aria-label="Open BurtHub in a new tab"
              dark
              small
              title="Open BurtHub in a new tab"
              @click="goToBurtHub"
            >
              <font-awesome-icon :icon="['far', 'up-right-from-square']" />
              <span class="ml-2">Open BurtHub</span>
            </v-btn>
          </v-col>
        </v-row>
      </v-col>
    </v-row>

    <v-row
      v-if="showSummaries"
      class="mt-0"
    >
      <v-col class="py-0 ml-4 mr-5">
        <v-divider />
      </v-col>
    </v-row>

    <v-row
      v-if="showSummaries"
      class="mx-0 mb-0 mt-4"
    >
      <v-col>
        <summary-card-bar />
      </v-col>
    </v-row>

    <v-row
      v-if="showSummaries"
      class="mt-0"
    >
      <v-col class="pt-0 mx-4">
        <v-divider />
      </v-col>
    </v-row>

    <report-list v-if="showDashboard" />

    <v-row
      v-else
      class="ma-0"
    >
      <v-col>
        <data-table
          ref="table"
          :actions="actions"
        />

        <line-item-history-modal
          v-if="isLineItemHistoryModalVisible"
          v-model="isLineItemHistoryModalVisible"
          :line-item-record="currentRecord"
        />

        <creatives-report-modal
          v-if="isCreativesReportModalVisible"
          v-model="isCreativesReportModalVisible"
          :line-item-record="currentRecord"
        />

        <tearsheet-modal
          v-if="isCreativeModalVisible"
          v-model="isCreativeModalVisible"
          :line-item-record="currentRecord"
        />
      </v-col>
    </v-row>
  </v-col>
</template>

<script>
import { createNamespacedHelpers } from 'vuex'

import mixin from '../components/mixin'

const { mapState } = createNamespacedHelpers('delivery')
const { mapGetters: mapAuthGetters } = createNamespacedHelpers('auth')
const { mapGetters: mapMessagesGetters } = createNamespacedHelpers('messages')
const { mapGetters: mapToolsGetters, mapState: mapToolsState } = createNamespacedHelpers('tools')

export default {
  name: 'Pacing',
  components: {
    breadCrumbs: () => import('@/layout/components/BreadCrumbs'),
    creativesReportModal: () => import('../components/modals/CreativesReportModal'),
    lineItemHistoryModal: () => import('../components/modals/LineItemHistoryModal'),
    reportList: () => import('@/dashboard/components/ReportList'),
    summaryCardBar: () => import('@/tools/components/summary/SummaryCardBar'),
    tearsheetModal: () => import('../components/modals/TearsheetModal'),
  },
  mixins: [mixin],
  data() {
    return {
      actions: [
        {
          event: 'delivery/openTabToLineItem',
          name: 'Go to Line Item',
        },
        {
          event: 'delivery/openTabToOrder',
          name: 'Go to Order',
        },
        {
          event: 'delivery/showLineItemHistoryModal',
          name: '10-Day History Report',
        },
        {
          event: 'delivery/showCreativesReportModal',
          name: 'Creatives Report',
        },
        {
          event: 'delivery/showTearsheetModal',
          name: 'Preview & Tearsheet',
        },
      ],

      linkToBurtHub: 'https://us.burthub.com',
      linkToBurtForecast: 'https://jama-forecasting.us.burthub.com/',

      searchCollection: [],
    }
  },
  computed: {
    ...mapAuthGetters([
      'hasAccessToBurtHubLink',
      'hasAccessToBurtForecastLink',
    ]),
    ...mapToolsGetters([
      'showSummaries',
    ]),
    ...mapMessagesGetters(['currentMessage']),
    ...mapToolsState({
      reportId: (state) => state.reportId,
      reportName: (state) => state.reportName,
      searchResults: (state) => state.searchResults,
      selectedSearch: (state) => state.selectedSearch,
      summaries: (state) => state.summaries,
    }),
    ...mapState({
      currentRecord: (state) => state.currentRecord,
      isLineItemHistoryModalVisible: (state) => state.isLineItemHistoryModalVisible,
      isCreativesReportModalVisible: (state) => state.isCreativesReportModalVisible,
      isCreativeModalVisible: (state) => state.isCreativeModalVisible,
      publisher: (state) => state.publisher,
      subId: (state) => state.subId,
    }),
    showDashboard() {
      return this.selectedSearch?.dataType === 'custom'
    },
  },
  methods: {
    goToBurtForecast() {
      /**
       * @note Regarding the NoOpener,NoReferrer Policy
       * It's generally recommended to add rel="noopener noreferrer"
       * to links using target="_blank". When using window.open(),
       * we achieve a similar effect by passing noopener and
       * noreferrer as the third argument. This prevents the new
       * tab from accessing the original page's window.opener
       * object, mitigating potential security risks.
       */

      window.open(this.linkToBurtForecast, '_blank', 'noopener,noreferrer')
    },
    goToBurtHub() {
      /**
       * @note Regarding the NoOpener,NoReferrer Policy
       * It's generally recommended to add rel="noopener noreferrer"
       * to links using target="_blank". When using window.open(),
       * we achieve a similar effect by passing noopener and
       * noreferrer as the third argument. This prevents the new
       * tab from accessing the original page's window.opener
       * object, mitigating potential security risks.
       */

      window.open(this.linkToBurtHub, '_blank', 'noopener,noreferrer')
    },
  },
}
</script>

<style lang="scss" scoped>
@import "~src/styles/variables";

::v-deep.filter-link {
  margin-top: 8px;
}

::v-deep.filter-content {
  margin-top: 16px;
}

::v-deep.filter-label {
  padding-top: 20px;
}

.delivery-table-filter {
  .first-row {
    display: flex;

    .v-text-field {
      margin: 0 24px;
      padding-top: 0;
      font-size: 12px;
    }
  }

  .second-row {
    display: flex;
    ::v-deep.v-text-field {
      margin: 0 24px;
      padding-top: 0;
      font-size: 12px;
    }

    .osi-selector {
      max-width: 350px;
    }

    .filter-controls-spacer {
      min-height: 52px;
    }
  }

  ::v-deep.v-date-range {
    .v-text-field {
      min-width: 250px !important;
    }
  }
}
</style>
